<script type="text/javascript">
	import { createEventDispatcher,onMount } from "svelte";
	import { writable } from "svelte/store";

	import API from "../../API/API";
	import DateDialect from "../../Enums/DateDialect";
	import DateRestriction from "../../Enums/DateRestriction";
	import LngLatFormat from "../../Enums/LngLatFormat";
	import Company from "../../Models/Company";
	import ModelType from "../../Models/ModelType";
	import FeaturesOverrides from "./FeaturesOverrides.svelte";
	import AdminStore from "./Store";

	import Button,{ Label } from '@smui/button';
	import DataTable,{ Body,Cell,Head,Row } from '@smui/data-table';
	import Textfield from "@smui/textfield";
	import Datepicker from "svelte-calendar";
	import Form from './Form.svelte';
	import SpinnerButton from "./SpinnerButton.svelte";

	import Feature from "../../Branding/Feature";

	import CommentVisibility from "../../Models/Enums/CommentVisibility";

	export let company = null;

	const dispatch = createEventDispatcher(); // submit | reset | delete

	const Loading = {
		NONE: -1,
		SAVING_COMPANY: 1,
		DELETING_COMPANY: 2
	};

	let form = null;
	let loading = writable(Loading.NONE);
	$: if (form) form.setReadOnly($loading != Loading.NONE);

	let tiers = AdminStore.cms.tiers;
	let allRois = AdminStore.cms.rois;

	let currentTier = null;
	let accessibleROIs = [];
	let accessibleAlertTypes = [];

	let setEditableMatrix = (editable, company) => {
		currentTier = AdminStore.helpers.getTierByName(editable.tier_name);
		accessibleROIs = currentTier.rois;
		accessibleAlertTypes = currentTier.alertTypes.map((item) => { return item.code; });
		console.log("currentTier&*", currentTier);
		console.log("accessibleROIs", accessibleROIs);
		console.log("accessibleAlertTypes", accessibleAlertTypes);

		editable.meta.alert_type_roi_pairs = {};

		for(let i = 0; i < accessibleROIs.length; i++) {
			for(let j = 0; j < accessibleAlertTypes.length; j++) {
				let roiId = accessibleROIs[i].id;
				let alertTypeCode = accessibleAlertTypes[j];

				let key = roiId + "_" + alertTypeCode;
				editable.meta.alert_type_roi_pairs[key] = {
					checked: company.hasAlertTypeROIPair(alertTypeCode, roiId),
					roi_id: roiId,
					alert_type_code: alertTypeCode
				};
			}
		}
	}

	let createEditable = (company) => {
		let editable = {
			name: company.name,
			imos: company.imos,
			tier_id: company.tierId,
			tier_name: (company.tierName=="None") ? $tiers[0].name : company.tierName,
			meta: {
				alert_type_roi_pairs: {}
			},
			extra_data: company.extraData,
			feature_overrides: company.featureOverrides
		}
		if (!editable.extra_data.settings) {
			editable.extra_data.settings = JSON.parse(JSON.stringify(Company.defaults.extra_data.settings));
		}
		setEditableMatrix(editable, company);

		console.log('created editable', editable);
		return editable;
	}
	let editable = createEditable(company);

	let onSelectAllMatrix = () => {
		const keys = Object.keys(editable.meta.alert_type_roi_pairs);
		for(let i = 0; i < keys.length; i++) {
			editable.meta.alert_type_roi_pairs[keys[i]].checked = true;
		}
	};
	let onDeselectAllMatrix = () => {
		const keys = Object.keys(editable.meta.alert_type_roi_pairs);
		for(let i = 0; i < keys.length; i++) {
			editable.meta.alert_type_roi_pairs[keys[i]].checked = false;
		}
	};
	let onTierChanged = () => {
		setEditableMatrix(editable, company);
	};

	let onReset = () => {
		editable = createEditable(company);
		console.log("init/reset editable", editable);
		dispatch('reset');
	}
	let onDelete = () => {
		AdminStore.cms.confirmDialog.onConfirm = () => {
			$loading = Loading.DELETING_COMPANY;
			API.delete("admin/companies/" + company.id)
				.then((response)=>{
					console.log(response);
					form.snackbar.start("Company deleted successfully.", "success");
					AdminStore.actions.deleteCompany(company);
					dispatch('delete');
				})
				.catch((e)=>{
					console.error(e.data.title, e.data.detail);
					form.snackbar.start("Company deletion failed.", "error");
				})
				.finally(()=>{
					$loading = Loading.NONE;
					AdminStore.cms.confirmDialog.visible.set(false);
				});
		}
		AdminStore.cms.confirmDialog.visible.set(true);
	}
	let onSubmit = () => {

		let tier = AdminStore.helpers.getTierByName(editable.tier_name);
		if (tier === null) {
			form.snackbar.start("Invalid Tier.", "error");
			return;
		}

		let data = {
			name: editable.name,
			imos: editable.imos,
			tier_id: tier.id,
			alert_type_roi_pairs: Object.values(editable.meta.alert_type_roi_pairs).filter((item) => { return item.checked; }),
			extra_data: editable.extra_data
		}
		console.log('submit data', data);
		if (company.isNew()) {
			data.features = {};
		}
		else {
			data.features = editable.feature_overrides;
		}

		let n = company.isNew();
		let url = n ? "admin/companies/create" : "admin/companies/" + company.id;
		$loading = Loading.SAVING_COMPANY;
		API.put("admin/companies/" + company.id, data)
			.then((response) =>{
				console.log("response", response);
				if (company.isNew()) {
					AdminStore.actions.addCompany(company);
				}
				company.setData(response);
				onReset();
				form.snackbar.start("Company " + (n ? "created" : "updated") + " successfully.", "success");
				dispatch('submit', {company});
			})
			.catch((error)=>{
				console.error(error.data.title, error.data.detail);
				form.snackbar.start("Company " + (n ? "create" : "update") + " failed.", "error");
			})
			.finally(() =>{
				$loading = Loading.NONE;
			})

	};

	onMount(()=>{
		onReset();
	});

	const today = new Date();
	const datePickerStrFormat = "#{F} #{j}, #{Y}";//"#{d}/#{m}/#{Y}"
	let fromDateTimeStore = writable(new Date());
	let fromFormattedSelected;
	$: {
		if (editable.extra_data.vessel_history.date_restriction === DateRestriction.FIXED_DATE) {
			editable.extra_data.vessel_history.date_restriction_value = $fromDateTimeStore.toISOString();
		}
		else if (editable.extra_data.vessel_history.date_restriction === DateRestriction.NONE) {
			editable.extra_data.vessel_history.date_restriction_value = "";
		}
	}

</script>

<Form bind:this={form} id='admin-company-form'>
	{#if company.isNew()}
		<h2>New Company</h2>
	{:else}
		<h2>Existing Company</h2>
	{/if}

	<DataTable table$aria-label="Company">
		<Head>
			<Row>
				<Cell></Cell>
				<Cell></Cell>
			</Row>
		</Head>
		<Body>
			<Row>
				<Cell>Name</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.name}/>
				</Cell>
			</Row>
			<Row>
				<Cell>Tier</Cell>
				<Cell>
					<select class='default' bind:value={editable.tier_name} on:change={onTierChanged}>
						{#each $tiers as tier}
							<option value={tier.name} selected={editable.tier_name === tier.name}>{tier.name}</option>
						{/each}
					</select>
				</Cell>
			</Row>
			<Row>
				<Cell>IMOs</Cell>
				<Cell>
					<Textfield dense variant="outlined" label="Comma-separated IMOs for generating Alerts" bind:value={editable.imos} />
				</Cell>
			</Row>
			<Row>
				<Cell>Map</Cell>
				<Cell>
					<div style='padding-top:10px;'>
						<Textfield dense variant="outlined" label="Map - Home Position - Lng" bind:value={editable.extra_data.map.home.lng}/><br/>
					</div>
					<div style='padding-top:10px;'>
						<Textfield dense variant="outlined" label="Map - Home Position - Lat" bind:value={editable.extra_data.map.home.lat}/><br/>
					</div>
					<div style='padding-top:10px;padding-bottom:10px;'>
						<Textfield dense variant="outlined" label="Map - Home Position - Zoom Level" bind:value={editable.extra_data.map.home.zoom}/>
					</div>
				</Cell>
			</Row>


			<Row>
				<Cell>Date Dialect</Cell>
				<Cell>
					<select class='default' bind:value={editable.extra_data.settings.date_dialect}>
						{#each Object.keys(DateDialect) as dialectKey}
							{#if DateDialect[dialectKey] === ""}
								<!-- Show nothing -->
							{:else}
								<option value={DateDialect[dialectKey]} selected={editable.extra_data.settings.date_dialect === DateDialect[dialectKey]}>{dialectKey}</option>
							{/if}
						{/each}
					</select>
				</Cell>
			</Row>
			<Row>
				<Cell>LngLat Format:</Cell>
				<Cell>
					<select class='default' bind:value={editable.extra_data.settings.lnglat_format}>
						{#each Object.keys(LngLatFormat) as formatKey}
							{#if LngLatFormat[formatKey] === ""}
								<!-- Show nothing -->
							{:else}
								<option value={LngLatFormat[formatKey]} selected={editable.extra_data.settings.lnglat_format === LngLatFormat[formatKey]}>{formatKey}</option>
							{/if}
						{/each}
					</select>
				</Cell>
			</Row>

			<Row>
				<Cell>Comment Thread Visibility:</Cell>
				<Cell>
					<select class='default' bind:value={editable.extra_data.comments.default_thread_visibility}>
						<option value={CommentVisibility.PUBLIC} selected={editable.extra_data.comments.default_thread_visibility === CommentVisibility.PUBLIC}>Public - {CommentVisibility.toDescription(CommentVisibility.PUBLIC)}</option>
						<option value={CommentVisibility.PROTECTED} selected={editable.extra_data.comments.default_thread_visibility === CommentVisibility.PROTECTED}>Private (default) - {CommentVisibility.toDescription(CommentVisibility.PROTECTED)}</option>
						<option value={CommentVisibility.PRIVATE} selected={editable.extra_data.comments.default_thread_visibility === CommentVisibility.PRIVATE}>Private - {CommentVisibility.toDescription(CommentVisibility.PRIVATE)}</option>
					</select>
				</Cell>
			</Row>


			<Row>
				<Cell>Vessel History</Cell>
				<Cell>
					<div style='padding-top:10px;'>
						<b>Time Restriction:</b><br/>
						<select class='default' bind:value={editable.extra_data.vessel_history.date_restriction}>
							<option value={DateRestriction.NONE} selected={editable.extra_data.vessel_history.date_restriction === DateRestriction.NONE}>None</option>
							<option value={DateRestriction.FIXED_LENGTH} selected={editable.extra_data.vessel_history.date_restriction === DateRestriction.FIXED_LENGTH}>Fixed Length</option>
							<option value={DateRestriction.FIXED_DATE} selected={editable.extra_data.vessel_history.date_restriction === DateRestriction.FIXED_DATE}>Fixed Date</option>
							<!--
							{#each Object.keys(DateRestriction) as restrictionKey}
								<option value={DateRestriction[restrictionKey]} selected={editable.extra_data.vessel_history.date_restriction === DateRestriction[restrictionKey]}>{restrictionKey}</option>
							{/each}
							-->
						</select>
					</div>

					<!-- {#if editable.extra_data.vessel_history.date_restriction === DateRestriction.NONE}
						<div style='padding-top:10px;display:none;'>
							<select class='default' bind:value={editable.extra_data.vessel_history.date_restriction_value}>
								<option value=""></option>
							</select>
						</div>
					{/if} -->
					{#if editable.extra_data.vessel_history.date_restriction === DateRestriction.FIXED_LENGTH}
						<div style='padding-top:10px;'>
							<select class='default' bind:value={editable.extra_data.vessel_history.date_restriction_value}>
								{#each [7,31,90,180,365,730,1095] as numDays}
									<option value={numDays * 86400}>{numDays} days</option>
								{/each}
							</select>

						</div>
					{/if}
					{#if editable.extra_data.vessel_history.date_restriction === DateRestriction.FIXED_DATE}
						<div style='padding-top:10px;padding-bottom:10px;'>
							<Datepicker
							end={today}
							format={datePickerStrFormat}
							bind:selected={$fromDateTimeStore}
							bind:formattedSelected={fromFormattedSelected}>
								<Button color="secondary" variant="unelevated" style="width:100%;"><Label>From: {fromFormattedSelected}</Label></Button>
							</Datepicker>
						</div>
					{/if}

					<!-- Data chunking metadata for Spire requests -->
					<div style='padding-top:10px;'>
						<b>One Point Per Day / Downsampling:</b><br/>
						<select class='default' bind:value={editable.extra_data.vessel_history.oppd_sample_length}>
							<option value={86400}>Sample whole day</option>
							<option value={3600}>Sample only first hour</option>
						</select>
						<!-- <div>
							<select class='default' bind:value={editable.extra_data.vessel_history.request_data_segmentation.size}>
								{#if editable.extra_data.vessel_history.request_data_segmentation.stride >= 86400 * 7}
									<option value={86400 * 7}>First Week</option>
								{/if}
								<option value={86400}>First Day</option>
								<option value={3600}>First Hour</option>
							</select>
						</div>
						<div>
							<select class='default' bind:value={editable.extra_data.vessel_history.request_data_segmentation.stride}>
								<option value={86400 * 7}>Of Each Week</option>
								<option value={86400}>Of Each Day</option>
							</select>
						</div> -->

						<!-- <p>The backend will pull the first {day} of each {week}</p> -->
					</div>

					{#if currentTier !== null &&
			 			currentTier.features[Feature.VESSEL_HISTORY.RESTRICTED_INPUTS] === 1}
						<div style='padding-top:10px;'>
							<Textfield dense variant="outlined" label="Limited IMOs (comma-separated)" bind:value={editable.extra_data.vessel_history.restricted_imos} />
						</div>
						<div style='padding-top:10px;padding-bottom:10px;'>
							<Textfield dense variant="outlined" label="Limited MMSIs (comma-separated)" bind:value={editable.extra_data.vessel_history.restricted_mmsis} />
						</div>
					{/if}
				</Cell>
			</Row>


			<Row>
				<Cell class='cell-align-top'>Alert Type / ROI Matrix</Cell>
				<Cell>
					<table style="padding:10px;">
						<tr>
							<td style="text-align:center;height:28px;">Region of Interest</td>
							{#each accessibleAlertTypes as at}
								<td><span class="shortcode">{at}</span></td>
							{/each}
						</tr>
						{#each Object.keys(accessibleROIs) as roiKey}
							<tr>
								<td style="font-weight:normal;">{accessibleROIs[roiKey].name}</td>
								{#each accessibleAlertTypes as at}
									<td style="padding:2px;width:text-align:center;">
										<!-- <span class="shortcode"> -->
										<input
											class='alert-roi-matrix-checkbox'
											data-alerttype={at}
											data-roi={accessibleROIs[roiKey].id}
											type='checkbox'
											bind:checked={editable.meta.alert_type_roi_pairs[accessibleROIs[roiKey].id + "_" + at].checked}
											style="height:28px;padding:0px;margin:0px;display:inline-block;vertical-align:middle;"/>
										<!-- </span> -->
									</td>
								{/each}
							</tr>
						{/each}
					</table>
					<!-- <button>Select all</button>
					<button>Deselect all</button> -->

					<Button on:click={onSelectAllMatrix} color="primary" class="bg-info" variant="unelevated"><Label>Select All</Label></Button><br/>
					<Button on:click={onDeselectAllMatrix} color="primary" class="bg-info" variant="unelevated"><Label>Deselect All</Label></Button><br/><br/>
				</Cell>
			</Row>
		</Body>
	</DataTable>

	{#if !company.isNew()}
		<FeaturesOverrides editable={editable} model={company} modelType={ModelType.COMPANY} />
	{/if}

	<h2 style={"width:100%;margin-top:10px;margin-bottom:0px;"}>Actions</h2>
	{#if $loading == Loading.SAVING_COMPANY}
		<SpinnerButton/>
	{:else}
		<Button on:click={onSubmit} color="primary" variant="unelevated"><Label>{((!company.isNew())?"Update Company":"Add Company")}</Label></Button>
	{/if}

	<Button on:click={onReset} color="primary" class="bg-info" variant="unelevated"><Label>Reset</Label></Button>

	<hr/>

	{#if company.id > 1}
		<Button color="secondary" variant="unelevated" class="bg-error" on:click={onDelete}><Label>Delete Company</Label></Button>
	{/if}

	<hr/>

	<h1>TODO:</h1>
	<ul>
		<li>User List</li>
		<li>Monthly Plan?</li>
		<li>Generated Invoices?</li>
	</ul>
	<!-- <div style='background-color:#ff9999;margin-top:10px;padding:10px;border-radius:3px;'>
		<h2>Monthly Plan:</h2>
		<p><i>Plan renews on:</i> 12/45/5678</p>
		<p>• Tier: £123456</p>
		<p>• Additional Users: 10 at £30 each</p>
		<p><b>Total:</b> £192232</p>
		<hr/>

		<h2>Invoices:</h2>
		<p>• March 2020: ... PENDING</p>
		<p>• February 2020: ... PAID</p>
	</div> -->


</Form>
